import { gql } from '@apollo/client';

export default gql`
  mutation setInitialPhaseForUser($phaseUuid: String!) {
    setInitialPhaseForUser(phaseUuid: $phaseUuid)
  }
`;
